<div class="delete_icon">
    <i class="material-icons pointer" title="{{ 'CONSTANTS.REMOVE' | translate }}" (click)="deleteNode()">delete_outline</i>
</div>